window.addEventListener("load", () => {
  const productHandle = new URLSearchParams(window.location.search).get("p");
  const editID = new URLSearchParams(window.location.search).get("edit");
  let serviceCart = Cookies.get("serviceCart");

  let mode; // first-time-mode, edit-mode, or adding-product-mode
  let productId;

  // Set repair catalog mode
  if (typeof serviceCart === "undefined") {
    mode = "first-time-mode";
  } else if (editID !== null) {
    mode = "edit-mode";
    serviceCart = JSON.parse(Cookies.get("serviceCart"));
    document.getElementsByClassName("question")[0].innerText =
      "You're currently editing a repair cart item. Select All the issues you need fixed.";
  } else if (editID === null) {
    serviceCart = JSON.parse(Cookies.get("serviceCart"));
    mode = "adding-product-mode";
  }

  // Show or hide terms and conditons based on click of checkbox.
  document.getElementById("agreeToTAC").addEventListener("click", function () {
    this.checked
      ? (document.getElementById("estimate").style.display = "flex")
      : (document.getElementById("estimate").style.display = "none");
  });

  // Warning announcement for customer's who selected the Nintendo Switch
  if (productHandle == "nintendo-switch") {
    document.getElementById("dataWarning").innerHTML = `
            <ul style="display: flex; align-items: center; justify-content: center; flex-direction: column; padding: 5; margin: 0;">
                <li>JoesGE does not repair Nintendo Switches with water damage.</li>
                <li>We do not repair Nintendo Switch Lites.</li>
                <li style="list-style-type: none;">
                    <img alt="Nintendo Switch Light" src="https://i.imgur.com/ftI40ls.png" style="max-width:112px; margin:0;"/>
                </li>
            </ul>
        `;
    document.getElementById("dataWarning").style.textAlign = "center";
    document.getElementById("dataWarning").style.display = "block";
  }

  if (productHandle == "copy-pro-service") {
    document.querySelector(
      "#dataWarning"
    ).innerHTML = `<strong>Important</strong>: We do not repair <strong>red</strong> Beats pros. Please do not send them in if they are red.`;
    document.querySelector("#dataWarning").style.display = "block";
    document.querySelector("#dataWarning").style.textAlign = "center";
  }

  // Gets information related to selected product and displays a list of issue variants for the product
  const getProductData = (productHandle) => {
    axios
      .get(`/products/${productHandle}.js`)
      .then((response) => {
        console.info(response);
        document.getElementById("productTitle").innerText = response.data.title;
        document.getElementById("productImg").src =
          response.data.featured_image;
        const issuesUl = document.getElementById("model-issues");
        productId = response.data.id;
        for (let variant of response.data.variants) {
          const issueItem = document.createElement("li");
          const { title, id, price, weight } = variant;
          const { src } = variant["featured_image"];
          issueItem.setAttribute("id", `issue-${title}-${id}`);
          issueItem.innerHTML = `
                        <label class="repair-issue-class" for="${id}">
                            <input 
                                type="checkbox" 
                                id="${id}" 
                                value="${title}" 
                                name="issues" 
                                hidden 
                                onclick="issueSelected(this)" 
                                data-cost=${
                                  Math.round(parseFloat(price)) / 100
                                } 
                                data-weight=${weight}
                            >
                                ${title}
                                <img 
                                    src="${src}" 
                                    style="max-width: 50px"
                                />
                            </input>
                        </label>
                    `;
          issuesUl.appendChild(issueItem);
        }
      })
      .catch((error) => console.error(error));
  };

  getProductData(productHandle);

  // When the customer clicks the "NEXT" button, add, create or edit a serviceCart cookie based on issues selected.
  document
    .getElementById("estimate")
    .addEventListener("click", function (event) {
      event.preventDefault();
      try {
        let variantList = {};
        // querySelectorAll will return a collection of Node objects.
        let selectedIssues = document.querySelectorAll(
          "input[name^='issues']:checked"
        );
        if (selectedIssues.length > 0) {
          for (let i = 0; i < selectedIssues.length; i++) {
            variantList[selectedIssues[i].id] = {
              cost: selectedIssues[i].getAttribute("data-cost"),
              title: selectedIssues[i].value,
            };
          }

          let details = {
            productHandle,
            productTitle: document.getElementById("productTitle").innerText,
            featuredImage: document.getElementById("productImg").src,
            variantList,
            editID,
            weight: selectedIssues[0].getAttribute("data-weight"),
            productId,
          };

          if (mode == "first-time-mode") {
            firstTimeMode(details);
          } else if (mode == "edit-mode") {
            editMode(details);
          } else if (mode == "adding-product-mode") {
            addingProductMode(details);
          }
        } else {
          throw new Error("No issue has been selected.");
        }
      } catch (error) {
        console.error(error);
        document.title = "Error: Please select an issue";
        document.getElementsByClassName("question")[0].innerHTML =
          "<b>Error: Please select an issue</b>";
        window.scrollTo({top: 0, behavior: "smooth"});
      }
    });
});


function issueSelected(checkbox) {
  updateButton();
  document.getElementsByClassName("question")[0].innerHTML = "<b>Select device issues:</b>";

  if (isScreenPolishing(checkbox)) {
    const banner = document.getElementById("screenPolishingBanner");
    if (checkbox.checked) {
      banner.style.display = "block"
      window.scrollTo({top: banner.offsetTop, behavior: "smooth"});
    } else {
      banner.style.display = "none"; 
    }
  }
  if (isDataRecovery(checkbox)) {
    if (checkbox.checked) {
      checkbox.parentNode.style.border = "2px solid #ed1d26";
      document.getElementById("dataWarning").style.display = "grid";
      document.getElementById("estimate").style.display = "none";
      let selectedIssues = document.querySelectorAll(
        "input[name^='issues']:not([value='DATA RECOVERY']):checked"
      );
      if (selectedIssues.length > 0) {
        for (let i = 0; i < selectedIssues.length; i++) {
          selectedIssues[i].checked = false;
          selectedIssues[i].parentNode.style.border = "1px solid rgba(171,171,171,.73)";
        }
      }
    } else {
      document.getElementById("estimate").style.display = "flex";
      document.getElementById("agreeToTAC").checked = false;
      document.getElementById("dataWarning").style.display = "none";
      checkbox.parentNode.style.border = "1px solid rgba(171,171,171,.73)";
    }
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  } else {
    document.getElementById("dataWarning").style.display = "none";
    document.getElementById("estimate").style.display = "flex";
    document.getElementById("agreeToTAC").checked = false;
    let dataRecovery = document.querySelector("input[name^='issues'][value='DATA RECOVERY']");
    if (dataRecovery) {
      dataRecovery.checked = false;
      dataRecovery.parentNode.style.border = "1px solid rgba(171,171,171,.73)";
    }
    if (checkbox.checked) {
      checkbox.parentNode.style.border = "2px solid #ed1d26";
    } else {
      checkbox.parentNode.style.border = "1px solid rgba(171,171,171,.73)";
    }
  }
}

function updateButton(){
  let selectedIssues = document.querySelectorAll(
    "input[name^='issues']:checked"
  );
  const seeEstimateButton = document.getElementById("estimate");
  if (selectedIssues.length > 0) {
    seeEstimateButton.removeAttribute("disabled");
  } else {
    seeEstimateButton.setAttribute("disabled","disabled");
  }
}

const isDataRecovery = (input) =>
  input.value === "DATA RECOVERY" ? true : false;

const isScreenPolishing = (input) =>
  input.value === "SCREEN POLISHING" ? true : false;